/**
 * @generated SignedSource<<906967c5a04b52b1c73288e1f86cc168>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UnsubscribeCard_notificationSubscriptions$data = {
  readonly id: string;
  readonly surveyInvites: boolean | null;
  readonly " $fragmentType": "UnsubscribeCard_notificationSubscriptions";
};
export type UnsubscribeCard_notificationSubscriptions$key = {
  readonly " $data"?: UnsubscribeCard_notificationSubscriptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"UnsubscribeCard_notificationSubscriptions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UnsubscribeCard_notificationSubscriptions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surveyInvites",
      "storageKey": null
    }
  ],
  "type": "NotificationSubscriptions",
  "abstractKey": null
};

(node as any).hash = "d6c35e7969a5fe11a0dbbe15bbc119ea";

export default node;
